import Vue from "vue";
import Vuex from "vuex";

import color from "@/store/modules/color";
import dicom from "@/store/modules/dicom";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { color, dicom },
});
